import InterceptTrack from "./InterceptTrack.js";
import {getNewCoordinates, inverseHeading, getRunwayHeading} from "../../assets/virtual-flyout/nav-calc.js";
import {getVref} from "../../assets/virtual-flyout/perf-calc.js";
import {descend, setTas} from "../planeSlice.js";
import {getActiveRunway, getAirportDetails} from "../../assets/virtual-flyout/airport-service.js";

const FINAL_HEIGHT = 400;

export default class JoinFinal extends InterceptTrack {

    constructor(planeId, airport) {
        super(planeId);
        this.airport = airport;
        this.interceptAngle = 90;
    }

    logAction() {}

    execute() {
        const planeState = this.getState();
        this.runway = getActiveRunway(this.airport.code, planeState.wind.heading).runway;
        this.waypoint1 = getNewCoordinates(this.airport, 2, inverseHeading(getRunwayHeading(this.runway)) );
        this.waypoint2 = this.airport;
        super.execute();

        const airportDetails = getAirportDetails(this.airport.code);
        this.dispatch(descend({altitude: airportDetails.elevation + FINAL_HEIGHT}));
        this.dispatch(setTas({tas: getVref() + 10}));
    }
}
